import { useRef, useState } from "react";
import api from "./api";

/* Runs a long AI endpoint as a background job (?job=1) and polls /ai-jobs/{id}
   every 2s. Resolves with the endpoint's normal response; rejects with an Error(message). */
export async function runAiJob(url, body, onTick) {
  const sep = url.includes("?") ? "&" : "?";
  const { data } = await api.post(`${url}${sep}job=1`, body);
  const start = Date.now();
  for (;;) {
    await new Promise((r) => setTimeout(r, 2000));
    onTick?.(Math.round((Date.now() - start) / 1000));
    const { data: j } = await api.get(`/ai-jobs/${data.job_id}`);
    if (j.status === "done") return j.result;
    if (j.status === "error") throw new Error(j.error || "AI action failed");
  }
}

export function useAiJob() {
  const [busy, setBusy] = useState(false);
  const [elapsed, setElapsed] = useState(0);
  const alive = useRef(true);
  const run = async (url, body) => {
    setBusy(true); setElapsed(0);
    try { return await runAiJob(url, body, (s) => alive.current && setElapsed(s)); }
    finally { if (alive.current) setBusy(false); }
  };
  return { busy, elapsed, run, label: (base) => (busy ? `${base}… ${elapsed}s` : base) };
}
